import React from "react";
import { motion, Transition } from "framer-motion";
import {
  Integrity,
  Environmental,
  CustomerCentricity,
  SocialGovernance,
} from "../../../assets/svgs/icon";
import OurWorkCultureCard from "../../../components/OurWorkCultureCard";

const workCultureData = [
  {
    id: 1,
    title: `Integrity`,
    desc: `Integrity is the foundation of our work culture at ECOCYNTEC Limited. 
        We uphold the highest ethical standards in all our interactions and decision-making processes. Trust and transparency are key principles that guide our relationships with clients, partners, and colleagues.`,
    icon: Integrity,
  },
  {
    id: 2,
    title: `Environmental`,
    desc: `Environmental Responsibility is a fundamental value that shapes our work culture. We are dedicated to minimizing our environmental impact and promoting sustainable practices. From incorporating eco-friendly technologies to embracing renewable energy sources, we actively contribute to a greener future.`,
    icon: Environmental,
  },
  {
    id: 3,
    title: `Customer Centricity`,
    desc: `Customer Centricity is at the core of our work culture. We are committed to understanding and meeting the unique needs of our clients. We prioritize exceptional customer service and strive to exceed expectations in every project we undertake. Our focus on customer satisfaction drives us to deliver innovative and tailored solutions.`,
    icon: CustomerCentricity,
  },
  {
    id: 4,
    title: `Social & Governance`,
    desc: `Social & Governance consciousness is an integral part of our work culture. We recognize the importance of social responsibility and believe in giving back to the communities we serve. We are committed to fostering diversity, inclusion, and equal opportunities within our organization and beyond. Good governance practices ensure transparency, accountability, and responsible decision-making.`,
    icon: SocialGovernance,
  },
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const springTransition: Transition = {
  type: "spring",
  stiffness: 120,
  damping: 20,
};

const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: springTransition },
};

const OurWorkCultures = () => {
  return (
    <div className="mt-10 md:mt-5 w-full h-auto flex flex-col items-center justify-center bg-backgroundColor mx-auto px-2 md:px-10">
      <motion.div
        initial={{ x: -150, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 100, damping: 15, delay: 0.2 }}
        className="flex flex-col items-center justify-center md:px-24"
      >
        <h2 className="font-CrimsonText font-bold text-2xl md:text-4xl text-primaryColor pb-5">
          Our Work Culture
        </h2>
      </motion.div>

      <motion.p
        initial={{ x: 150, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 100, damping: 15, delay: 0.4 }}
        className="pb-5 font-CrimsonText font-normal text-base lg:text-xl text-textColor text-center md:px-24"
      >
        At ECOCYNTEC Limited, our work culture is characterized by a strong
        commitment to Integrity, Customer Centricity, Environmental
        Responsibility, and Social & Governance consciousness. Join our team and
        be part of a work environment that values these principles, promotes
        collaboration, and empowers you to make a meaningful impact in the
        energy industry.
      </motion.p>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className=" w-full flex items-center lg:justify-between justify-around flex-wrap flex-col md:flex-row "
        //className="w-full h-auto flex-col md:flex-row md:flex items-center justify-around md:justify-between md:gap-4 px-0 md:px-24 flex-wrap"
      >
        {workCultureData.map((work) => {
          const Icon = work.icon;
          return (
            <motion.div key={work.id} variants={cardVariants}>
              <OurWorkCultureCard
                title={work.title}
                desc={work.desc}
                icon={<Icon />}
              />
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  );
};

export default OurWorkCultures;
